import React from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useLocation, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Get, Put} from '@app/utils/httpProvider';
import {useQuery, useQueryClient, useMutation} from 'react-query';
import Editor from '@app/components/editor/Editor';
import 'react-tabs/style/react-tabs.css';
import {
    messageError,
    messageToast,
    status200,
    role,
    objectLoaiNoiDung,
    styleSelectError,
    styleSelectDefault
} from '../../utils/define';
import {
    BaseGatewayImage,
    APIROLEMAPPING_API,
    AUTH_APIROLEMAPPING_API,
    ROLE_API
} from '../../utils/apiUrl.js';
import {getInfomationAccountFromToken, isValidUrl} from '../../utils/helper';
import DatePicker from '@app/components/CustomDatePicker';
import loginHistory from '@app/store/reducers/loginHistory';
import {NIL as NIL_UUID} from 'uuid';
import Select from 'react-select';
import {AsyncPaginate} from 'react-select-async-paginate';
import {apiRoleMappingPagingAction} from '@app/store/reducers/apiRoleMapping';
import {useDispatch} from 'react-redux';

const schema = yup.object().shape({
    controller: yup.string().required('Bắt buộc'),
    lstAllowedRoles: yup.array().min(1, 'Phải chọn ít nhất 1 quyền')
});

const ApiRoleMappingEdit = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');
    const mappingSource = paramUrl.get('source') === 'auth' ? 'auth' : 'webapi';
    const mappingApi = mappingSource === 'auth'
        ? AUTH_APIROLEMAPPING_API
        : APIROLEMAPPING_API;

    // const inforAccount = getInfomationAccountFromToken();
    // let accountRoleManageDevice = false;

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleManageDevice =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    //     // accountRoleBooker =
    //     //     userRole.includes(role.Admin) || userRole.includes(role.Booker);
    // }

    const itemEdit = useQuery(['apiRoleMappingItem', mappingSource, itemId], () =>
        Get(mappingApi.GET_ITEM, itemId)
    );

    console.log('itemEdit', itemEdit);

    const editFunc = useMutation((value) =>
        Put(mappingApi.UPDATE_ITEM, itemId, value)
    );

    const handleEdit = async (values) => {
        const model = {...values};

        model.id = itemId;

        model.lstAllowedRoles = values.lstAllowedRoles.map((x) => ({
            id: x.value,
            name: x.label
        }));

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    dispatch(
                        apiRoleMappingPagingAction({
                            PageIndex: 1,
                            PageSize: 10000
                        })
                    );
                    queryClient.setQueryData(itemId, model);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRole =
        listRole &&
        listRole.data &&
        listRole.data.data &&
        listRole.data.data.length > 0
            ? listRole.data.data.map((x) => ({
                  label: x.name,
                  value: x.id
              }))
            : [];

    // const loadOptions = async (inputValue, loadedOptions, {page}) => {
    //     console.log('lstRole', lstRole);
    //     const filteredOptions = lstRole
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    const loadOptions = async (inputValue, loadedOptions, {page}) => {
        const filtered = lstRole
            .filter((o) =>
                o.label.toLowerCase().includes(inputValue.toLowerCase())
            )
            .slice(0, 6);
        return {
            options: filtered,
            hasMore: false,
            additional: {page: page + 1}
        };
    };

    const isLoading = itemEdit.isLoading ? true : false;
    const isError = itemEdit.isError ? true : false;
    const error = itemEdit.isError ? itemEdit.error : null;

    return (
        <Card>
            <Card.Header as="h5">Xem hoặc sửa Api Role Mapping</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Đang tải...</div>
                ) : isError ? (
                    <div>Có lỗi xảy ra: ${error.message}</div>
                ) : itemEdit.data == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            controller:
                                itemEdit.data && itemEdit.data.controller
                                    ? itemEdit.data.controller
                                    : '',
                            action:
                                itemEdit.data && itemEdit.data.action
                                    ? itemEdit.data.action
                                    : '',
                            lstAllowedRoles:
                                itemEdit.data &&
                                itemEdit.data.lstAllowedRoles &&
                                itemEdit.data.lstAllowedRoles
                                    ? itemEdit.data.lstAllowedRoles.map(
                                          (x) => ({
                                              label: x.name,
                                              value: x.id
                                          })
                                      )
                                    : []
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên controller
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên controller"
                                            type="text"
                                            name="controller"
                                            value={values.controller}
                                            onChange={handleChange}
                                            isInvalid={!!errors.controller}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.controller}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên action
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên action"
                                            type="text"
                                            name="action"
                                            value={values.action}
                                            onChange={handleChange}
                                            isInvalid={!!errors.action}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.action}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Quyền được cho phép truy cập
                                    </Form.Label>
                                    <Col sm="10">
                                        <AsyncPaginate
                                            isMulti
                                            name="lstAllowedRoles"
                                            placeholder="Chọn quyền được cho phép truy cập"
                                            value={values.lstAllowedRoles}
                                            loadOptions={loadOptions} // your existing loadOptions
                                            styles={
                                                errors.lstAllowedRoles
                                                    ? styleSelectError
                                                    : styleSelectDefault
                                            }
                                            onChange={(options) => {
                                                setFieldValue(
                                                    'lstAllowedRoles',
                                                    options
                                                );
                                            }}
                                            additional={{
                                                page: 1
                                            }}
                                        />
                                        <div
                                            className="invalid-feedback"
                                            style={{display: 'block'}}
                                        >
                                            {errors.lstAllowedRoles}
                                        </div>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{span: 10, offset: 2}}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default ApiRoleMappingEdit;
